import React from 'react';
import styled from 'styled-components';
import Number from './HomeStepNumber';

import {media} from '../styles/breakpoints';

const HomeStep = ({ children, number }) => {
    const StyledHomeStep = styled.div`
        
        & .schnoffle-homestep-logo {
          text-align: right;
          margin: 0;
        }

        & .schnoffle-homestep-logo-schnoffle {
          text-align: right;
          margin: 0.5em 0 1.31em;
        }
        
        & img {
          width: 60vw;
          max-width: 300px;
          margin: 1em auto 0 auto;

          ${media.tweak600up`margin-top: 0.1em;`}
          
        }
    `;

    const StyledHomeStepNumber = styled.div`
        float: left;
        width: 5em;
        margin: 0 2.5em 0 0;
        shape-outside: circle();

        ${media.tweak600up`width: 2.5em;`}
    `;

    return (
        <StyledHomeStep>
            <StyledHomeStepNumber>
                <Number number={number} />
            </StyledHomeStepNumber>
            {children}
        </StyledHomeStep>
    );
};

export default HomeStep;



// WEBPACK FOOTER //
// ./src/components/home/HomeStep.js